import { computed, Injectable, signal, TemplateRef } from '@angular/core';

/**
 * A slot in `fr8bot-ui-page-header` that a component further down the page can fill — the way
 * `fr8bot-ui-list-filters` moves its «Filters» button up next to the view toggle on compact
 * screens. `fr8bot-ui-page-template` provides one per page; the header renders `template()` in
 * front of its `[right]` content.
 *
 * `hasHeader()` is set by the header itself, so a page-template without a header (the fleet
 * board's map) never swallows a button nobody would render.
 */
@Injectable()
export class PageHeaderActions {
  private readonly headers = signal(0);
  private readonly current = signal<TemplateRef<unknown> | null>(null);

  readonly hasHeader = computed(() => this.headers() > 0);
  readonly template = this.current.asReadonly();

  attachHeader(): () => void {
    this.headers.update((count) => count + 1);

    return () => this.headers.update((count) => count - 1);
  }

  show(template: TemplateRef<unknown>): void {
    this.current.set(template);
  }

  /** Only clears its own template, so a later owner that replaced it keeps the slot. */
  hide(template: TemplateRef<unknown>): void {
    if (this.current() === template) {
      this.current.set(null);
    }
  }
}
